import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const GalleryR = () => {
  const images = [
    //1//
    {
      src: "/img/portfolio/RECADRAGE/k1rabbwb9r3tl9vvos9e_compression.jpg",
      alt: "Photo 1",
      category: "Reportage",
    },
    {
      src: "/img/reportage/1/gllhfjvi4hdaycvir1vk_compression.jpg",
      alt: "Photo 2",
      category: "Reportage",
    },
    {
      src: "/img/reportage/1/pqz94gr7jnqogg2fjo5j_compression.jpg",
      alt: "Photo 3",
      category: "Reportage",
    },

    //2//

    {
      src: "/img/reportage/2/sr0wcg39brmosvs2ku04_compression.jpg",
      alt: "Photo 4",
      category: "Reportage",
    },
    {
      src: "/img/reportage/2/gj6xudlkdcvi8mtrehx8_compression.jpg",
      alt: "Photo 5",
      category: "Reportage",
    },
    {
      src: "/img/reportage/2/ml5zk1ndbdpk9h34jsg3_compression.jpg",
      alt: "Photo 6",
      category: "Reportage",
    },
    //3//
    {
      src: "/img/reportage/3/igv5kjaccrr0e30qmrtb_compression.jpg",
      alt: "Photo 7",
      category: "Reportage",
    },
    {
      src: "/img/reportage/3/cvrwafoldvg2n3frocxq_compression.jpg",
      alt: "Photo 8",
      category: "Reportage",
    },

    {
      src: "/img/reportage/3/c4ivtudlog2eh1kq3spu_compression.jpg",
      alt: "Photo 9",
      category: "Reportage",
    },

    //4//

    {
      src: "/img/reportage/4/cvc4qy7l3myvd7bgtopb_compression.jpg",
      alt: "Photo 10",
      category: "Reportage",
    },
    {
      src: "/img/reportage/4/pfnjqtyhnrv2kwvjnrln_compression.jpg",
      alt: "Photo 11",
      category: "Reportage",
    },
    {
      src: "/img/reportage/4/fhb1dfbzoicwrcbtgk7a_compression.jpg",
      alt: "Photo 12",
      category: "Reportage",
    },

    //5//
    {
      src: "/img/reportage/5/xxggpycrcoq0vsritznp_compression.jpg",
      alt: "Photo 13",
      category: "Reportage",
    },
    {
      src: "/img/reportage/5/uxfuvrgfopesdgquvtpq_compression.jpg",
      alt: "Photo 14",
      category: "Reportage",
    },
    {
      src: "/img/reportage/5/kmvlzunl5dckdjs41bxy_compression.jpg",
      alt: "Photo 15",
      category: "Reportage",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      {/* Section Header */}
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/reportage//3/c4ivtudlog2eh1kq3spu_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Reportage</h1>
              <hr className="border-1 text-white" />
              <p>
                Découvrez le reportage photographique, où chaque image raconte
                une histoire unique avec authenticité.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Portfolio */}
      <section className="section-padding bg-blck">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div key={index} className="col-md-4 gallery-item">
                <div
                  className="img-zoom"
                  onClick={() => {
                    setPhotoIndex(index);
                    setIsOpen(true);
                  }}
                >
                  <div className="gallery-box">
                    <div className="gallery-img">
                      <img
                        src={image.src}
                        className="img-fluid mx-auto d-block"
                        alt={image.alt}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {isOpen && (
          <Lightbox
            images={images.map((img) => ({ url: img.src, title: img.title }))}
            startIndex={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        )}
      </section>
    </>
  );
};

export default GalleryR;
